export default "__VITE_ASSET__ra4jM2CU__"